import type { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiCardStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            '&.referralIntroWrapper': {
                padding: '16px 24px 24px 24px',
            },
            '.referral &': {
                padding: variables.padding.cardPadding,
            },
            '.referralDetails': {
                padding: '10px 0',
            },
            '&.introRegistration': {
                border: 'none',
                boxShadow: 'none',
            },
        },
    },
});

export default createMuiCardStyles;
